import dayjs from './dayjs';
import {API} from '../api';
import store from '../store';
import i18n from '../i18n';
import {EB as EventBus} from './bus'
import AES from 'crypto-js/aes';
import enc_utf8 from 'crypto-js/enc-utf8';
import axios from 'axios';
import {SPUserV4} from './SPUserV4';
import {global_shops} from './global_config';
import {replace_shop_username} from './_replace';
import {
  cf,
  escape_regex,
  execute_browser,
  get_value_by_path,
  xget_shopee,
  xpost_shopee,
  check_role,
  client_decode_json,
  client_encode_json,
  copy_object,
  copy_text, format_currency, format_currency_with_decimal, get_proxy,
  includes_fixed_list,
  includes_fixed_shop,
  is_percent_of, logo_channel,
  percent_of, remove_unicode,
  scroll_to_top_element, timeFormat, VND,
  is_mobile_device,
} from './function';

export default {
  install(Vue) {
    const EB = EventBus

    Vue.prototype.EB = EB
    Vue.prototype.API = API
    Vue.config.productionTip = false
    Vue.prototype.dayjs = dayjs
    Vue.prototype.atosa_device = 'web'
    Vue.prototype.enable_global = process.env.ENABLE_GLOBAL === 'true'

    Vue.prototype.ads_constant = {
      TARGETING_MIN_BASE_PRICE: 480,
      TARGETING_MIN_PREMIUM: 0,
      TARGETING_MAX_PREMIUM: 300
    }

    Vue.prototype.ntf_e = (data) => {
      EB.$emit('NTF_error', data)
    }

    Vue.prototype.confirm = (message, callback) => {
      EB.$emit('quick_confirm', {
        message: message,
        callback: callback
      })
    }

    Vue.prototype.ntf_w = (data) => {
      EB.$emit('NTF_warning', data)
    }

    Vue.prototype.cfm_w = (data) => {
      EB.$emit('CFM_warning', data)
    }

    Vue.prototype.ntf_s = (data) => {
      EB.$emit('NTF_success', data)
    }

    Vue.prototype.percent_of = percent_of
    Vue.prototype.is_percent_of = is_percent_of

    Vue.prototype.request_to_shopee = async function (data) {
      return await axios.post(API.URL_API_SRV_2 + '/shopee/request_to_shopee', data, cf())
    }

    Vue.prototype.search_items = async function (data) {
      EB.$emit('NTF_warning', i18n.t('main.change_to_app_message'))
    }

    Vue.prototype.includes_fixed_shop = includes_fixed_shop

    Vue.prototype.includes_fixed_list = includes_fixed_list

    Vue.prototype.has_advanced_ads = function () {
      return store.state.advanced_ads_list.some(i => store.state.userInfo.username.includes(i))
    }

    Vue.prototype.has_vit_ads = function () {
      return store.state.vit_ads_list.some(i => store.state.userInfo.username.includes(i))
    }

    Vue.prototype.has_agency_plan = function () {
      if (store.state.agency_plan_list.some(i => store.state.userInfo.username.includes(i))) {
        return true
      }

      const agency = store.state.package && store.state.package.extend_package && store.state.package.extend_package.find(i => i.package && i.package.channel === 'shopee_marketing_plan')
      if (agency) {
        return dayjs().isBefore(dayjs(new Date(agency.license_to)), 's')
      }

      const pack = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing')
      return !!(pack && pack.package && pack.package.extra_data && pack.package.extra_data.marketing && pack.package.extra_data.marketing.agency_plan)

    }

    Vue.prototype.spike_day_map = function (row, original = true) {
      if (row.type === 'flash_sale') return i18n.t('day.flash_sale')
      if (row.type === 'mini_spike_day') return i18n.t('day.mini_spike_day')
      if (row.type === 'before_flash_sale') return i18n.t('day.before_flash_sale_x_days', {x: row.day_number})
      if (row.type === 'after_flash_sale') return i18n.t('day.after_flash_sale_x_days', {x: row.day_number})
      if (row.type === 'day') return i18n.t('day.the_x_of_every_month', {x: row.day_number})
      if (row.type === 'remain') return original ? i18n.t('day.remaining_days') : i18n.t('day.every_day')
      if (row.type === 'daterange') return i18n.t('day.from_to')
      if (row.type === 'daily') return i18n.t('day.every_day')
      if (row.type === 'weekly') return i18n.t('day.every_week')
      if (row.type === 'monthly') return i18n.t('day.every_month')
      if (row.type === 'from_to') {
        if (row.date_range && row.date_range.length === 2) {
          return i18n.t('day.from_x_to_y', {
            x: dayjs(row.date_range[0]).format('DD/MM'),
            y: dayjs(row.date_range[1]).format('DD/MM')
          })
        } else {
          return i18n.t('day.from_to')
        }
      }
      if (row.type === 'after_x_days') return i18n.t('day.after_x_days', {x: row.day_number})
      if (row.type === 'exclude_sale') return i18n.t('day.exclude_sale')

      return ''
    }

    Vue.prototype.spike_day_to_text = function (spike_days, row) {
      const current_month = dayjs().month()
      const next_month = dayjs().add(1, 'month').month()

      if (row.type === 'mini_spike_day') {
        let filter_mini_spike_day = spike_days.filter(i => i.type === 'mini_spike_day' && dayjs().month(i.month - 1).date(i.day).isSameOrAfter(dayjs(), 'day'))
        if (!filter_mini_spike_day.length) filter_mini_spike_day = spike_days

        const mini_spike_day = filter_mini_spike_day.find(i => i.month === current_month + 1 && i.type === 'mini_spike_day')
        const next_mini_spike_day = filter_mini_spike_day.find(i => i.month === next_month + 1 && i.type === 'mini_spike_day')

        const sp_date = mini_spike_day ? dayjs().date(mini_spike_day.day).month(mini_spike_day.month - 1) : null
        return sp_date && sp_date.isSameOrAfter(dayjs(), 'day') ? `${i18n.t('day.from')} ${mini_spike_day.day}/${mini_spike_day.month}` : `${i18n.t('day.from')} ${next_mini_spike_day.day}/${next_mini_spike_day.month}`
      }

      if (row.type === 'black_friday') {
        const black_friday = spike_days.find(i => i.type === 'black_friday')
        const sp_date = dayjs().date(black_friday.day).month(black_friday.month - 1)
        return sp_date.isSameOrAfter(dayjs(), 'day') ? `${i18n.t('day.from')} ${black_friday.day}/${black_friday.month}` : `${i18n.t('day.from')} ${black_friday.day}/${black_friday.month + 1}`
      }

      const spike_day = spike_days.find(i => i.month === current_month + 1 && i.type === 'spike_day')
      const next_spike_day = spike_days.find(i => i.month === next_month + 1 && i.type === 'spike_day')
      if (!spike_day) return ''

      const sp_date = dayjs().date(spike_day.day).month(spike_day.month - 1)

      if (row.type === 'flash_sale') {
        return sp_date.isSameOrAfter(dayjs(), 'day') ? `${i18n.t('day.from')} ${spike_day.day}/${spike_day.month}` : `${i18n.t('day.from')} ${next_spike_day.day}/${next_spike_day.month}`
      }

      if (row.type === 'before_flash_sale') {
        const flash_sale = dayjs().date(spike_day.day).month(spike_day.month - 1)
        const next_flash_sale = dayjs().date(next_spike_day.day).month(next_spike_day.month - 1)

        if (sp_date.isSameOrAfter(dayjs(), 'day')) {
          return `${i18n.t('day.from')} ${flash_sale.subtract(+row.day_number, 'day').date()}/${spike_day.month} ${i18n.t('day.to')} ${spike_day.day - 1}/${spike_day.month}`
        } else {
          return `${i18n.t('day.from')} ${next_flash_sale.subtract(+row.day_number, 'day').date()}/${next_spike_day.month} ${i18n.t('day.to')} ${next_spike_day.day - 1}/${next_spike_day.month}`
        }
      }

      if (row.type === 'after_flash_sale') {
        const flash_sale = dayjs().date(spike_day.day).month(spike_day.month - 1)
        const next_flash_sale = dayjs().date(next_spike_day.day).month(next_spike_day.month - 1)
        return sp_date.isSameOrAfter(dayjs(), 'day') ? `${i18n.t('day.from')} ${spike_day.day + 1}/${spike_day.month} ${i18n.t('day.to')} ${flash_sale.add(+row.day_number, 'day').date()}/${spike_day.month}` : `${i18n.t('day.from')} ${next_spike_day.day + 1}/${next_spike_day.month} ${i18n.t('day.to')} ${next_flash_sale.add(+row.day_number, 'day').date()}/${next_spike_day.month}`
      }
    }

    Vue.prototype.scroll_to_top_element = scroll_to_top_element

    Vue.prototype.copy_text = copy_text

    Vue.prototype.copy_object = copy_object

    Vue.prototype.format_currency = format_currency

    Vue.prototype.format_currency_with_decimal = format_currency_with_decimal

    Vue.prototype.open_link = (url, target = '_blank') => {
      window.open(url, target)
    }

    Vue.prototype.open_link_fixed = (url, shop) => {
      if (shop && shop.extra_data && !shop.extra_data.is_buff) {
        const global_found = global_shops.find(i => shop.extra_data && i.country === shop.extra_data.country)
        if (global_found) {
          window.open(url.replace(/shopee\.(vn|com)/ig, global_found.buyer_api), '_blank')
        } else {
          window.open(url, '_blank')
        }
      } else {
        window.open(url, '_blank')
      }
    }

    Vue.prototype.encrypt_data = (json) => {
      const key = 'NJts2WAoeYzAlj7lipkYhJSU'
      return AES.encrypt(JSON.stringify(json), key).toString()
    }

    Vue.prototype.decrypt_data = (data) => {
      const key = 'NJts2WAoeYzAlj7lipkYhJSU'
      const result = AES.decrypt(data, key).toString(enc_utf8)
      return JSON.parse(result)
    }

    Vue.prototype.contain_at_least = (base_keyword, compare) => {
      if (!base_keyword || !compare) return false

      if (base_keyword === compare) {
        return true
      }

      if (base_keyword.normalize() === compare.normalize()) {
        return true
      }

      if (base_keyword.includes(compare.normalize()) || compare.normalize().includes(base_keyword)) {
        return true
      }

      const split = compare.split(' ')
      for (const word of split) {
        if (base_keyword.normalize().includes(word.normalize())) {
          return true
        }
      }

      return false
    }

    Vue.prototype.VND = VND

    Vue.prototype.cf = Vue.prototype._cf = () => {
      if (typeof store.state.userInfo.token == 'undefined') {
        return {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      } else {
        return {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': store.state.userInfo.token
          }
        }
      }
    }

    const host = URL
    Vue.prototype.image_host = (file) => {
      if (file.length > 0) {
        return `${host}/static/${file}`
      } else {
        return '/static/img/logo.png'
      }
    }

    Vue.prototype.random_range = function (h, n) {
      return Math.floor(Math.random() * (h - n)) + n
    }

    Vue.prototype.is_trial = function (channel = 'shopee_marketing') {
      const pack = store.state.package && store.state.package.extend_package && store.state.package.extend_package.find(i => i.channel === channel)
      return pack && pack.package && pack.package.default_for_free
    }

    Vue.prototype.remove_unicode = remove_unicode

    Vue.prototype.escape_regex = escape_regex

    Vue.prototype.TRACKING = (data) => {
      return new Promise(async resolve => {
        try {
          let input_data = await client_encode_json(data)
          let resp = await axios.post(API.MIPEE_TRACKING, input_data, {headers: cf().headers})
          let data_x = resp.data.data
          let result = await client_decode_json(data_x.context, data_x.time)
          resolve(result.data)
        } catch (e) {
          resolve({})
        }
      })
    }

    Vue.prototype.get_proxy = get_proxy

    Vue.prototype.init_seller = async function (shop, ntf = true) {
      const seller = new SPUserV4()
      seller._id = shop._id
      seller.shop_id = shop.shop_id
      seller.cookie = shop.cookie
      seller.username = shop.username
      seller.password = shop.password
      seller.password_hash = shop.password_hash
      seller.is_buff = shop.extra_data.is_buff
      seller.proxy = get_proxy(shop)
      this.dayjs.setDefault('Asia/Ho_Chi_Minh')

      if (shop.extra_data && shop.extra_data.is_global && shop.extra_data.country) {
        const global_found = global_shops.find(i => i.country === shop.extra_data.country)
        if (global_found) {
          seller.seller_api = global_found.seller_api
          seller.account_api = global_found.account_api
          seller.buyer_api = global_found.buyer_api
          seller.is_floor = global_found.is_floor
          seller.timezone = global_found.timezone
          seller.country = global_found.country
          this.dayjs.setDefault(global_found.timezone)
        }
      }

      replace_shop_username(seller)

      try {
        await seller.get_shop_info()
      } catch (e) {
        console.error(e)
      }

      if (ntf) {
        if (shop.extra_data && shop.extra_data.is_banned && shop.extra_data.is_banned === true) {
          EB.$emit('CFM_warning', i18n.t('shop.error_banned'))
        } else if (shop.extra_data && shop.extra_data.wrong_pwd && shop.extra_data.wrong_pwd === true) {
          EB.$emit('CFM_warning', i18n.t('shop.error_require_captcha'))
        } else if (shop.extra_data && shop.extra_data.is_needed_otp && shop.extra_data.is_needed_otp === true) {
          EB.$emit('CFM_warning', i18n.t('shop.error_require_otp'))
        } else if (shop.extra_data && shop.extra_data.is_need_ivs && shop.extra_data.is_need_ivs === true) {
          EB.$emit('CFM_warning', i18n.t('shop.error_require_otp'))
        }
      }

      return seller
    }

    Vue.prototype.clone = function (data) {
      try {
        return JSON.parse(JSON.stringify(data))
      } catch (e) {
        console.error('data: ', data + ' - error: ' + e)
        return null
      }
    }

    Vue.prototype.sleep = function (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }

    Vue.prototype.check_role = check_role

    Vue.prototype.logo_channel = logo_channel

    Vue.prototype.timeFormat = timeFormat

    Vue.prototype.SHOPEE_IMAGE = (img) => {
      return typeof img !== 'undefined' && img.toString().trim().length > 0 ? 'https://cf.shopee.vn/file/' + img : 'https://static.atosa.asia/logo/shopee.png'
    }

    Vue.prototype.check_shop = async (sp_user) => {
      let shop_id = null
      let info_data = await sp_user.get_shop_info()
      try {
        shop_id = info_data.data.shopid
      } catch (e) {
      }

      if (!shop_id) {
        let json_data = await sp_user.seller_login()

        if (!json_data) {
          EB.$emit('CFM_warning', i18n.t('shop.connect_shop_error'))
          return false
        }

        if (typeof json_data.message !== 'undefined') {
          switch (json_data.message) {
            case 'error_perm': {
              EB.$emit('CFM_warning', i18n.t('shop.incorrect_account'))
              break
            }
            case 'error_banned': {
              EB.$emit('CFM_warning', i18n.t('shop.cannot_get_shop_info'))
              break
            }
            case 'error_require_captcha': {
              EB.$emit('CFM_warning', i18n.t('shop.error_require_captcha'))
              break
            }
            case 'error_too_frequent': {
              EB.$emit('CFM_warning', i18n.t('shop.error_require_captcha'))
              break
            }
            case 'error_captcha': {
              EB.$emit('CFM_warning', i18n.t('shop.error_captcha'))
              break
            }
            case 'error_notfound': {
              EB.$emit('CFM_warning', i18n.t('shop.incorrect_account'))
              break
            }
            case 'error_need_otp': {
              EB.$emit('CFM_warning', i18n.t('shop.error_require_otp'))
              break
            }
            case 'error_need_ivs': {
              EB.$emit('CFM_warning', i18n.t('shop.error_require_otp'))
              break
            }
            default: {
              EB.$emit('CFM_warning', JSON.stringify(json_data))
              break
            }
          }
          return false
        } else if (!json_data.username) {
          EB.$emit('CFM_warning', i18n.t('shop.connect_shop_error'))
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }

    Vue.prototype.execute_browser = execute_browser

    Vue.prototype.xget_shopee = xget_shopee

    Vue.prototype.xpost_shopee = xpost_shopee

    Vue.prototype.array_to_set = (array) => new Set(array)

    Vue.prototype.get_value_by_path = get_value_by_path

    Vue.prototype.is_mobile_device = is_mobile_device
  }
}



// WEBPACK FOOTER //
// ./src/addon/prototype.js